module.exports = __webpack_public_path__ + "img/geovendas-logo.6b19931e.png";